module.exports = __webpack_public_path__ + "6e1498b644ddbe3451795684abd6dea9.svg";